module.exports = __webpack_public_path__ + "static/media/in-a-tidal-wave.1f89ea7e.jpg";